'use client'

import { useTranslations } from 'next-intl'

import { FormFlagChip } from '@/features/order/order-form/components/widget/order-form-fields'

interface AdvancedTwapReduceOnlyToggleProps {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}

// The same Reduce chip as the Limit/Market tabs' order flags — same concept, same control.
export function AdvancedTwapReduceOnlyToggle({
  checked,
  onCheckedChange,
}: AdvancedTwapReduceOnlyToggleProps) {
  const t = useTranslations('orderForm')
  return (
    <div className="flex">
      <FormFlagChip pressed={checked} onPressedChange={onCheckedChange}>
        {t('reduce')}
      </FormFlagChip>
    </div>
  )
}
